import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from '../views/error/error.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FormsModule } from '@angular/forms';
import { AiRexModalComponent } from './components/ai-rex/ai-rex-modal.component';
import { TooltipModule } from 'primeng/tooltip';
import { RexFloatButtonDirective } from './directives/rex-float-button.directive';
import { NumberFormatDirective } from './directives/number-format.directive';
import { GlobalStepperComponent } from './components/global-stepper/global-stepper.component';
import { FloatingTipComponent } from './components/floating-tip/floating-tip.component';

@NgModule({
  declarations: [ErrorComponent, AiRexModalComponent, GlobalStepperComponent, FloatingTipComponent, RexFloatButtonDirective, NumberFormatDirective],
  imports: [
    RouterModule,
    CommonModule,
    TranslateModule,
    PerfectScrollbarModule,
    FormsModule,
    TooltipModule
  ],
  exports: [
    PerfectScrollbarModule,
    RouterModule,
    ErrorComponent,
    TranslateModule,
    CommonModule,
    FormsModule,
    AiRexModalComponent,
    TooltipModule,
    GlobalStepperComponent,
    FloatingTipComponent,
    RexFloatButtonDirective,
    NumberFormatDirective
  ]
})
export class SharedModule { }
